var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2amo0y2qia",
    width: "225%",
    height: "192.1%",
    x: "-62.5%",
    y: "-46.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#2amo0y2qia)",
    transform: "translate(-401 -700) translate(265 703) rotate(-15 98.394 -533.99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 0c1.105 0 2 .895 2 2h4c2.21 0 4 1.79 4 4v28c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h4c0-1.105.895-2 2-2h8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D44",
    d: "M24 2c2.21 0 4 1.79 4 4v28c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h5v2H4c-1.054 0-1.918.816-1.995 1.85L2 6v28c0 1.054.816 1.918 1.85 1.995L4 36h20c1.054 0 1.918-.816 1.995-1.85L26 34V6c0-1.105-.895-2-2-2h-5V2h5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E05C55",
    d: "M9.888 26.569l.087.077c.36.36.388.928.083 1.32l-.083.095-2.121 2.121c-.36.36-.928.388-1.32.083l-.095-.083-1.414-1.414c-.39-.39-.39-1.024 0-1.414.39-.391 1.024-.391 1.414 0l.707.707 1.415-1.415c.362-.362.934-.388 1.327-.077zM18 28c.552 0 1 .448 1 1s-.448 1-1 1h-5c-.552 0-1-.448-1-1s.448-1 1-1h5zm-8.112-9.431l.087.077c.36.36.388.928.083 1.32l-.083.095-2.121 2.121c-.36.36-.928.388-1.32.083l-.095-.083-1.414-1.414c-.39-.39-.39-1.024 0-1.414.39-.391 1.024-.391 1.414 0l.707.707 1.415-1.415c.362-.362.934-.388 1.327-.077zM22 20c.552 0 1 .448 1 1s-.448 1-1 1h-9c-.552 0-1-.448-1-1s.448-1 1-1h9zM9.888 10.569l.087.077c.36.36.388.928.083 1.32l-.083.095-2.121 2.121c-.36.36-.928.388-1.32.083l-.095-.083-1.414-1.414c-.39-.39-.39-1.024 0-1.414.39-.391 1.024-.391 1.414 0l.707.707 1.415-1.415c.362-.362.934-.388 1.327-.077zM22 12c.552 0 1 .448 1 1s-.448 1-1 1h-9c-.552 0-1-.448-1-1s.448-1 1-1h9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D44",
    d: "M18 0c1.105 0 2 .895 2 2v2c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2V2c0-1.105.895-2 2-2h8zm-.5 2h-7c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5h7c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/check-list.e7bee6c37cacfa38d139e3ef432f4f4e.svg";
export { ForwardRef as ReactComponent };